export default function NotFound(){
    return (
        <>
            This page was not found.
        </>
    )
}